import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { Router, CanActivateFn } from '@angular/router';
import { filter, map, take } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';

/**
 * Guard funcional para validar permisos de acceso a rutas.
 * Espera que los permisos estén cargados antes de decidir.
 * Uso en rutas:
 * canActivate: [permissionGuard],
 * data: { module: 'COTIZACIONES', permission: 'VEHICULOS_FULL_INICIAR_COTIZACION' }
 */
export const permissionGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const authService = inject(AuthService);

  const requiredModule = route.data?.['module'] as string | undefined;
  const requiredPermission = route.data?.['permission'] as string | undefined;
  const appCode = (route.data?.['appCode'] as string | undefined) || 'COLOCLIC';

  return toObservable(authService.permissionsLoaded).pipe(
    filter((loaded) => loaded),
    take(1),
    map(() => {
      if (requiredPermission && requiredModule) {
        if (authService.hasPermission(requiredModule, requiredPermission, appCode)) {
          return true;
        }
      } else if (requiredModule) {
        if (authService.hasModuleAccess(requiredModule, appCode)) {
          return true;
        }
      } else {
        return true;
      }

      console.warn(`[PermissionGuard] Acceso denegado a la ruta ${state.url}`);
      return router.createUrlTree(['/']);
    })
  );
};
